<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-body>
      <!-- form -->
      <b-tabs>
        <b-tab active>
          <template #title>
            <feather-icon icon="UsersIcon" />
            <span>ASIGNACIÓN DE USUARIOS</span>
          </template>
          <b-card-text>
            <b-card
              no-body
              class="mb-0"
            >
              <b-form>
                <b-row>
                  <b-col sm="5">
                    <div class="panel panel-default">
                      <div class="pannel-heading">
                        <label
                          for="ListUser"
                        >
                          Lista de usuarios
                        </label>
                      </div>
                      <div
                        class="pane-body"
                      >
                        <b-form-select
                          v-model="users"
                          :options="optionUsers"
                          multiple
                          :select-size="14"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    sm="2"
                    class="text-center"
                  >
                    <div class="position-relative form-group">
                      <b-button
                        block
                        variant="success"
                        @click="guardar"
                      >
                        <feather-icon icon="ArrowRightIcon" />
                      </b-button>
                    </div>
                    <div class="position-relative form-group">
                      <b-button
                        block
                        variant="danger"
                        @click="eliminar"
                      >
                        <feather-icon icon="ArrowLeftIcon" />
                      </b-button>
                    </div>
                  </b-col>
                  <b-col
                    sm="5"
                  >
                    <div class="panel panel-default">
                      <div class="pannel-heading">
                        <label
                          for="ListUser"
                        >
                          Usuarios Asignados
                        </label>
                      </div>
                      <div
                        class="pane-body"
                      >
                        <b-form-select
                          v-model="usersPermiso"
                          :options="optionUserPermiso"
                          multiple
                          :select-size="14"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="UserPlusIcon" />
            <span>CREACIÓN DE ENCUESTADOR</span>
          </template>
          <user-form
            :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
            :form-type="formType"
            :institucion-id="institucionId"
            @refetch-data="refetchData"
            @error-data="showError"
          />
        </b-tab>
      </b-tabs>
      <!--/ form -->
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BForm, BFormSelect, BButton, BTabs, BTab, BCardText,
} from 'bootstrap-vue'
import store from '@/store'
import UserForm from './UserForm.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormSelect,
    BButton,
    BTabs,
    BTab,
    BCardText,
    UserForm,
  },
  emits: ['update:is-busy-clonar', 'update:modal-show', 'update:data-edit'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      type: '',
      users: [],
      optionUsers: [],
      usersPermiso: [],
      optionUserPermiso: [],
      params: [],
      isAddNewSidebarActive: false,
      formType: '',
      dataEdit: '',
      institucionId: this.project.institucion.idInstitucion,
    }
  },
  mounted() {
    this.listarRegistros(this.project)
    this.listarAsingaciones(this.project)
  },
  methods: {
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros(this.project)
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    async guardar() {
      if (this.users.length === 0) {
        this.$bvToast.toast('Seleccione al menos un usuario', {
          title: 'Advertencia',
          variant: 'warning',
          solid: true,
        })
      }
      this.params = []
      this.users.forEach(dat => {
        this.params.push({
          estado: true,
          proyecto: {
            idProyecto: this.project.idProyecto,
          },
          usuario: {
            idUsuario: dat,
          },
        })
      })
      await store
        .dispatch('gsencuesta/USUARIO_PROYECTO_CREATE', this.params)
        .then(() => {
          // console.log(response)
          this.listarAsingaciones(this.project)
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
        })
    },
    async eliminar() {
      if (this.usersPermiso.length === 0) {
        this.$bvToast.toast('Seleccione al menos un usuario', {
          title: 'Advertencia',
          variant: 'warning',
          solid: true,
        })
      }
      this.params = []
      this.usersPermiso.forEach(dat1 => {
        this.optionUserPermiso.forEach(dat2 => {
          if (dat2.idProyectoUsuario === dat1) {
            this.params.push({
              estado: false,
              idProyectoUsuario: dat1,
              proyecto: {
                idProyecto: this.project.idProyecto,
              },
              usuario: {
                idUsuario: dat2.usuario.idUsuario,
              },
            })
          }
        })
      })
      await store
        .dispatch('gsencuesta/USUARIO_PROYECTO_DELETE', this.params)
        .then(() => {
          // console.log(response)
          this.listarAsingaciones(this.project)
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
        })
    },
    async listarRegistros(project) {
      this.optionUsers = []
      await store
        .dispatch('gsencuesta/USUARIO_FIND_ALL_BY_INSTITUCION', {
          idInstitucion: project.institucion.idInstitucion,
        })
        .then(response => {
          this.optionUsers = []
          response.forEach((dat, index) => {
            this.optionUsers.push({
              index,
              value: dat.idUsuario,
              text: `${dat.nombre} ${dat.apellidoPaterno} ${dat.apellidoMaterno}`,
            })
          })
          // this.optionUsers = response === undefined ? [] : response
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
        })
    },
    async listarAsingaciones(project) {
      this.optionUserPermiso = []
      await store
        .dispatch('gsencuesta/USUARIO_FIND_ALL_BY_PROYECTO', {
          idProyecto: project.idProyecto,
        })
        .then(response => {
          this.optionUserPermiso = []
          response.forEach((dat, index) => {
            this.optionUserPermiso.push({
              index,
              idProyectoUsuario: dat.idProyectoUsuario,
              value: dat.idProyectoUsuario,
              usuario: {
                idUsuario: dat.usuario.idUsuario,
              },
              text: `${dat.usuario.nombre} ${dat.usuario.apellidoPaterno} ${dat.usuario.apellidoMaterno}`,
            })
          })
          // this.optionUsers = response === undefined ? [] : response
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
        })
    },
  },
}
</script>
